module.exports = __webpack_public_path__ + "img/09-Natours-01.8a630dc5.png";